// @ts-nocheck
import * as Types from '../../../../../../../gql/generated/graphql.gen';

import { gql } from '@apollo/client';
import { PlanDataTableFragmentFieldsFragmentDoc } from '../../../../../../../components/fragments/argyle/plan-data-table/__gql__/plan-data-table-fragment.gen';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetInitialDataPagesSignupPlanQueryVariables = Types.Exact<{
  planPriceUuid: Types.Scalars['UUID']['input'];
  promotionCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetInitialDataPagesSignupPlanQuery = { __typename?: 'Query', planPrice?: { __typename?: 'PlanPrice', id: string, name: string, price: number, couponErrorReason?: string | null, subscriptionCoupon?: { __typename?: 'SubscriptionCoupon', discountAmount: number, duration: string, durationInMonths?: number | null } | null } | null };


export const GetInitialDataPagesSignupPlanDocument = gql`
    query getInitialDataPagesSignupPlan($planPriceUuid: UUID!, $promotionCode: String) {
  planPrice(id: $planPriceUuid, promotionCode: $promotionCode) {
    ...PlanDataTableFragmentFields
  }
}
    ${PlanDataTableFragmentFieldsFragmentDoc}`;

/**
 * __useGetInitialDataPagesSignupPlanQuery__
 *
 * To run a query within a React component, call `useGetInitialDataPagesSignupPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInitialDataPagesSignupPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInitialDataPagesSignupPlanQuery({
 *   variables: {
 *      planPriceUuid: // value for 'planPriceUuid'
 *      promotionCode: // value for 'promotionCode'
 *   },
 * });
 */
export function useGetInitialDataPagesSignupPlanQuery(baseOptions: Apollo.QueryHookOptions<GetInitialDataPagesSignupPlanQuery, GetInitialDataPagesSignupPlanQueryVariables> & ({ variables: GetInitialDataPagesSignupPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInitialDataPagesSignupPlanQuery, GetInitialDataPagesSignupPlanQueryVariables>(GetInitialDataPagesSignupPlanDocument, options);
      }
export function useGetInitialDataPagesSignupPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInitialDataPagesSignupPlanQuery, GetInitialDataPagesSignupPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInitialDataPagesSignupPlanQuery, GetInitialDataPagesSignupPlanQueryVariables>(GetInitialDataPagesSignupPlanDocument, options);
        }
export function useGetInitialDataPagesSignupPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInitialDataPagesSignupPlanQuery, GetInitialDataPagesSignupPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInitialDataPagesSignupPlanQuery, GetInitialDataPagesSignupPlanQueryVariables>(GetInitialDataPagesSignupPlanDocument, options);
        }
export type GetInitialDataPagesSignupPlanQueryHookResult = ReturnType<typeof useGetInitialDataPagesSignupPlanQuery>;
export type GetInitialDataPagesSignupPlanLazyQueryHookResult = ReturnType<typeof useGetInitialDataPagesSignupPlanLazyQuery>;
export type GetInitialDataPagesSignupPlanSuspenseQueryHookResult = ReturnType<typeof useGetInitialDataPagesSignupPlanSuspenseQuery>;
export type GetInitialDataPagesSignupPlanQueryResult = Apollo.QueryResult<GetInitialDataPagesSignupPlanQuery, GetInitialDataPagesSignupPlanQueryVariables>;